import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    feeStructures: [],
    feeRecords: [],
    selectedFeeRecord: null,
    studentFeeRecords: null,
    feeSummary: null,
    defaulters: null,
    collectionReport: null,
    classFeeReport: null,
    feeAuditLogs: null,
    feePaymentSubmissions: [],
    loading: false,
    error: null,
    response: null,
    statestatus: "idle",
    successMessage: null,
};

const feeSlice = createSlice({
    name: "fee",
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        getStructuresSuccess: (state, action) => {
            state.feeStructures = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getFeeRecordsSuccess: (state, action) => {
            state.feeRecords = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getStudentFeeSuccess: (state, action) => {
            state.studentFeeRecords = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getSingleRecordSuccess: (state, action) => {
            state.selectedFeeRecord = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getSummarySuccess: (state, action) => {
            state.feeSummary = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getDefaultersSuccess: (state, action) => {
            state.defaulters = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getCollectionReportSuccess: (state, action) => {
            state.collectionReport = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getClassReportSuccess: (state, action) => {
            state.classFeeReport = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getAuditLogsSuccess: (state, action) => {
            state.feeAuditLogs = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getPaymentSubmissionsSuccess: (state, action) => {
            state.feePaymentSubmissions = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        clearFeeRecordDetail: (state) => {
            state.selectedFeeRecord = null;
        },
        stuffDone: (state, action) => {
            state.loading = false;
            state.error = null;
            state.response = null;
            state.successMessage = action.payload || null;
            state.statestatus = "added";
        },
        getFailed: (state, action) => {
            state.response = action.payload;
            state.loading = false;
            state.error = null;
            state.statestatus = "failed";
        },
        getError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.statestatus = "failed";
        },
        underFeeControl: (state) => {
            state.loading = false;
            state.response = null;
            state.error = null;
            state.successMessage = null;
            state.statestatus = "idle";
        },
    },
});

export const {
    getRequest,
    getStructuresSuccess,
    getFeeRecordsSuccess,
    getStudentFeeSuccess,
    getSingleRecordSuccess,
    getSummarySuccess,
    getDefaultersSuccess,
    getCollectionReportSuccess,
    getClassReportSuccess,
    getAuditLogsSuccess,
    getPaymentSubmissionsSuccess,
    clearFeeRecordDetail,
    stuffDone,
    getFailed,
    getError,
    underFeeControl,
} = feeSlice.actions;

export const feeReducer = feeSlice.reducer;
